import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer className="footer">
        Copyright &#169; Mohsin Shah
    </footer>
  )
}

export default Footer;